import { gql } from "apollo-angular";

export const firebaseAuth = gql`
  mutation firebaseAuth($user: GoogleAuthInput) {
    firebaseUser: firebaseAuth(user: $user) {
      id
      UID
      Token
      Email
      Name
      Given_Name
      Family_Name
      Picture
      Locale
      Verified_Email
      Refresh_Token
      Created_At
      Updated_At
    }
  }
`;

export const updatedUserState = gql`
  mutation updateUserState($user: UserInput) {
    user: updateUserState(user: $user) {
      id
    }
  }
`;

export const sendRequest = gql`
  mutation sendRequest($message: String!) {
    sent: sendRequest(message: $message)
  }
`;

export const suscribeToNotification = gql`
  mutation suscribeToNotification(
    $notificationDevice: NotificationDeviceInput
  ) {
    notificationDevice: suscribeToNotification(
      notificationDevice: $notificationDevice
    ) {
      id
      Token_NotificationDevice
      State_NotificationDevice
      FK_Place
    }
  }
`;

export const updateDefaultCoin = gql`
  mutation updateDefaultCoin($FK_Coin: ID) {
    coin: updateDefaultCoin(FK_Coin: $FK_Coin) {
      id
      Name_Coin
      Symbol_Coin
      Sell_Coin
      Buy_Coin
    }
  }
`;

export const createCellar = gql`
  mutation createCellar($cellar: CellarInput) {
    cellar: createCellar(cellar: $cellar) {
      id
      Description
      Color
      State_Cellar
      Count
    }
  }
`;

export const createCreditNote = gql`
  mutation createCreditNote($docEB: DocEBInput) {
    createCreditNote(docEB: $docEB) {
      ... on EBResponse {
        id
        clave
      }
      ... on EBHaciendaError {
        error
      }
    }
  }
`;

export const createCreditNoteMT = gql`
  mutation createCreditNoteMT($docEB: DocEBInputMT) {
    createCreditNoteMT(docEB: $docEB) {
      ... on EBResponse {
        id
        clave
      }
      ... on EBHaciendaError {
        error
      }
    }
  }
`;

export const saveFeature = gql`
  mutation SaveFeature($feature: SaveFeatureInput) {
    saveFeature(feature: $feature)
  }
`;

export const editFeatureTag = gql`
  mutation editFeatureTag($feature: ID!, $tagId: ID!) {
    editFeatureTag(feature: $feature, tagId: $tagId)
  }
`;

export const updateInventoryAll = gql`
  mutation updateInventoryAll($inventory: UpdateInventoryInput) {
    updateInventoryAll(inventory: $inventory)
  }
`;

export const createInventory = gql`
  mutation createInventory($inventory: InventoryInput) {
    inventory: createInventory(inventory: $inventory) {
      id
      Description
      State_Inventory
      Count
    }
  }
`;

export const createBlackBox = gql`
  mutation createBlackBox($blackBox: BlackBoxInput!) {
    newBlackBox: createBlackBox(blackBox: $blackBox) {
      id
      Name_BlackBox
      State_BlackBox
      BlackBoxDetails {
        id
        Value_BlackBoxDetail
        Type {
          id
          Name_BlackBoxDetailType
        }
        Updated_At
      }
      User {
        id
        NickName_User
        Sudo
        UserState {
          id
          Name_UserState
        }
        Person {
          id
          Lastname_Person
          Name_Person
          DocumentId_Person
          Files {
            id
            Route_File
            Created_At
            Name_File
            FileType {
              id
            }
          }
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
        }
        Roles {
          id
          Name_Role
        }
      }
      Updated_At
    }
  }
`;

export const updateBlackBox = gql`
  mutation updateBlackBox($blackBox: BlackBoxInput!) {
    editedBlackBox: updateBlackBox(blackBox: $blackBox) {
      id
      Name_BlackBox
      State_BlackBox
      BlackBoxDetails {
        id
        Value_BlackBoxDetail
        Type {
          id
          Name_BlackBoxDetailType
        }
        Updated_At
      }
      User {
        id
        NickName_User
        Sudo
        UserState {
          id
          Name_UserState
        }
        Person {
          id
          Lastname_Person
          Name_Person
          DocumentId_Person
          Files {
            id
            Route_File
            Created_At
            Name_File
            FileType {
              id
            }
          }
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
        }
        Roles {
          id
          Name_Role
        }
      }
      Updated_At
    }
  }
`;

export const sendNotification = gql`
  mutation sendNotification($notification: NotificationInput) {
    count: sendNotification(notification: $notification)
  }
`;

export const createBlackBoxDetail = gql`
  mutation createBlackBoxDetail($blackBoxDetail: BlackBoxDetailInput!) {
    newBlackBoxDetail: createBlackBoxDetail(blackBoxDetail: $blackBoxDetail) {
      id
      Value_BlackBoxDetail
      Type {
        id
        Name_BlackBoxDetailType
      }
      Updated_At
    }
  }
`;

export const transactionBlackBoxDetail = gql`
  mutation transactionBlackBoxDetail($from: ID!, $to: ID!, $value: String!) {
    transactionBlackBoxDetail(from: $from, to: $to, value: $value)
  }
`;

export const updateBlackBoxDetail = gql`
  mutation updateBlackBoxDetail(
    $blackBoxDetail: BlackBoxDetailInput!
    $binnacle: String
    $FK_Bill: ID
  ) {
    editedBlackBoxDetail: updateBlackBoxDetail(
      blackBoxDetail: $blackBoxDetail
      binnacle: $binnacle
      FK_Bill: $FK_Bill
    ) {
      id
      Value_BlackBoxDetail
      Type {
        id
        Name_BlackBoxDetailType
      }
      Updated_At
    }
  }
`;

export const hideBlackBox = gql`
  mutation hideBlackBox($id: ID!) {
    hideBlackBox(id: $id)
  }
`;

export const restoreBlackBox = gql`
  mutation restoreBlackBox($id: ID!) {
    restoreBlackBox(id: $id)
  }
`;

export const handleCellarState = gql`
  mutation handleCellarState($id: ID!, $state: Int!) {
    changed: handleCellarState(id: $id, state: $state)
  }
`;

export const removeInventory = gql`
  mutation deleteInventory($id: ID!) {
    inventory: deleteInventory(id: $id)
  }
`;

export const createInventoryDetail = gql`
  mutation createInventoryDetail($detail: InventoryDetailInput) {
    detail: createInventoryDetail(detail: $detail)
  }
`;

export const hideInventoryDetail = gql`
  mutation hideInventoryDetail($id: ID!) {
    detail: hideInventoryDetail(id: $id) {
      id
      Product {
        id
        ProductState {
          id
          State
        }
      }
    }
  }
`;

export const updateCellar = gql`
  mutation update($cellar: CellarUpdate) {
    cellar: updateCellar(cellar: $cellar) {
      id
      Place {
        id
      }
      State_Cellar
      Description
      Color
      Created_At
      Updated_At
    }
  }
`;

export const updateInventory = gql`
  mutation update($inventory: InventoryUpdate) {
    inventory: updateInventory(inventory: $inventory) {
      id
      Description
      State_Inventory
      Count
    }
  }
`;

export const updateInventoryDetail = gql`
  mutation updateInventoryDetail($detail: InventoryDetailUpdate) {
    detail: updateInventoryDetail(detail: $detail)
  }
`;

export const restoreInventoryDetail = gql`
  mutation restoreInventoryDetail($id: ID!) {
    detail: restoreInventoryDetail(id: $id) {
      id
      Product {
        id
        ProductState {
          id
          State
        }
      }
    }
  }
`;

export const createFeatureFile = gql`
  mutation createFeatureFile($file: FeatureFileInput) {
    file: createFeatureFile(newFile: $file) {
      id
      Route_File
      Created_At
      FileType {
        id
      }
    }
  }
`;

export const addProductDetail = gql`
  mutation addProductDetail($featureDetail: ProductFeatureDetailInput) {
    featureDetail: addProductDetail(featureDetail: $featureDetail) {
      id
      FK_ProductFeature
      Value_ProductFeatureDetail
      Key_ProductKeyFeature
      FK_ProductKeyFeature
    }
  }
`;

export const updateProductDetail = gql`
  mutation updateProductDetail($featureDetail: ProductFeatureDetailUpdate) {
    featureDetail: updateProductDetail(featureDetail: $featureDetail) {
      id
      FK_ProductFeature
      Value_ProductFeatureDetail
      Key_ProductKeyFeature
      FK_ProductKeyFeature
    }
  }
`;

export const removeProductDetail = gql`
  mutation removeProductDetail($id: ID!) {
    removeProductDetail(id: $id)
  }
`;

export const createFeature = gql`
  mutation createFeature($feature: ProductFeatureInput) {
    feature: createFeature(feature: $feature) {
      id
      Quantity_ProductFeature
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      ProductPrice {
        id
        Price_ProductPrice
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
          Created_At
          Updated_At
        }
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
      }
    }
  }
`;

export const updateFeaturePrice = gql`
  mutation updateFeaturePrice($feature: FeaturePrice) {
    price: updateFeaturePrice(feature: $feature) {
      id
      Tax {
        id
        Description_Tax
        MH_Code
      }
      Tariff {
        id
        Name
        Code
        Percent
        Created_At
        Updated_At
      }
      Cabys {
        id
        Name
        Percent
        Code
      }
      Discount {
        id
        Quantity
        StartDate
        EndDate
      }
      ProductionPrice
      Price_ProductPrice
      Coin {
        id
        Name_Coin
        Symbol_Coin
        Sell_Coin
        Buy_Coin
      }
    }
  }
`;

export const updateFeatureQuantity = gql`
  mutation updateFeatureQuantity($feature: FeatureQuantity) {
    quantity: updateFeatureQuantity(feature: $feature)
  }
`;

export const removeFeatureFile = gql`
  mutation removeFeatureFile($id: String, $FK_ProductFeature: ID) {
    removeFeatureFile(id: $id, FK_ProductFeature: $FK_ProductFeature)
  }
`;

export const addProductTag = gql`
  mutation addProductTag($productTag: ProductTagInput) {
    tag: addProductTag(productTag: $productTag) {
      id
      Value
    }
  }
`;

export const removeProductTag = gql`
  mutation deleteProductTag($FK_Product: ID!, $FK_Tag: ID!) {
    removed: deleteProductTag(FK_Product: $FK_Product, FK_Tag: $FK_Tag)
  }
`;

export const updateInventoryState = gql`
  mutation updateInventoryState($id: ID, $State_Inventory: Int) {
    inventory: updateInventoryState(
      id: $id
      State_Inventory: $State_Inventory
    ) {
      id
    }
  }
`;

export const createProductFeatureCode = gql`
  mutation createProductFeatureCode(
    $featureCode: ProductFeatureCodeInput
    $FK_Place: ID
  ) {
    codes: createProductFeatureCode(
      featureCode: $featureCode
      FK_Place: $FK_Place
    ) {
      id
      FeatureCode
      CodeType {
        id
        Name_CodeType
      }
    }
  }
`;

export const createDeliveryForPlaceAdmin = gql`
  mutation createDeliveryForPlaceAdmin(
    $bills: [ID]
    $FK_Place: ID
    $FK_User: ID
  ) {
    delivery: createDeliveryForPlaceAdmin(
      bills: $bills
      FK_Place: $FK_Place
      FK_User: $FK_User
    ) {
      id
      Created_At
      Updated_At
      DeliveryState {
        id
        Name_DeliveryState
      }
    }
  }
`;

export const updateBillDetailState = gql`
  mutation updateBillDetailState($id: ID, $state: ID, $quantity: Int) {
    detail: updateBillDetailState(id: $id, state: $state, quantity: $quantity) {
      id
      Quantity_BillDetail
      State {
        id
        Name_BillDetailState
      }
    }
  }
`;

export const checkBillDetail = gql`
  mutation checkBillDetail($id: ID, $quantity: Float) {
    detail: checkBillDetail(id: $id, quantity: $quantity) {
      id
      CheckedByDelivery_BillDetail
      State {
        id
        Name_BillDetailState
      }
    }
  }
`;

export const updateDeliveryState = gql`
  mutation updateDeliveryState($delivery: DeliveryInput) {
    delivery: updateDeliveryState(delivery: $delivery) {
      id
      DeliveryState {
        id
        Name_DeliveryState
      }
    }
  }
`;

export const ordersReadyToCollect = gql`
  mutation ordersReadyToCollect($id: Int!, $forceComplete: Boolean) {
    ordersReadyToCollect(id: $id, forceComplete: $forceComplete) {
      status
      message
      hasPending
      notFound
    }
  }
`;
export const removeTagProduct = gql`
  mutation removeTagProduct($tagId: Int!) {
    removeTagProduct(tagId: $tagId) {
      message
      status
    }
  }
`;

export const removeSubTag = gql`
  mutation removeSubTag($tagId: Int!) {
    removeSubTag(tagId: $tagId) {
      message
      status
    }
  }
`;
export const updateBillDetailForShopperB = gql`
  mutation updateBillDetailForShopperB($details: [BillDetailToUpdate]) {
    updated: updateBillDetailForShopperB(details: $details)
  }
`;

export const updateBillDetailsToDelivered = gql`
  mutation updateBillDetailsToDelivered(
    $details: [BillDetailToUpdate]
    $FK_Place: ID
  ) {
    updated: updateBillDetailsToDelivered(
      details: $details
      FK_Place: $FK_Place
    )
  }
`;

export const createPlaceFile = gql`
  mutation createPlaceFile($FK_Place: ID, $File: FileInput) {
    placeFile: createPlaceFile(FK_Place: $FK_Place, File: $File)
  }
`;

export const createBillForCashier = gql`
  mutation createBillForCashier(
    $bill: PayingBillForCashierInput
    $detail: [PayingBillDetailForCashierInput]
  ) {
    newBill: createBillForCashier(bill: $bill, detail: $detail) {
      id
      Details_Bill
    }
  }
`;

export const assignNewTaxToProduct = gql`
  mutation assignNewTaxToProduct($id: ID, $FK_Product: ID) {
    tax: assignNewTaxToProduct(id: $id, FK_Product: $FK_Product) {
      id
      Description_Tax
    }
  }
`;

export const cloneInventoryDetail = gql`
  mutation cloneInventoryDetail($detail: InventoryDetailInput) {
    inventoryDetail: cloneInventoryDetail(detail: $detail)
  }
`;

export const moveInventoryDetailOfInventory = gql`
  mutation moveInventoryDetailOfInventory($FK_Inventory: ID, $FK_Product: ID) {
    result: moveInventoryDetailOfInventory(
      FK_Inventory: $FK_Inventory
      FK_Product: $FK_Product
    )
  }
`;

export const updateRestrictedProduct = gql`
  mutation updateRestrictedProduct($id: ID, $Restricted_Product: Boolean) {
    updated: updateRestrictedProduct(
      id: $id
      Restricted_Product: $Restricted_Product
    )
  }
`;

export const payWithAccountFromCashier = gql`
  mutation payWithAccountFromCashier($FK_Account: ID, $Total: String) {
    paid: payWithAccountFromCashier(FK_Account: $FK_Account, Total: $Total)
  }
`;

export const payBillCashierMultiple = gql`
  mutation payBillCashierMultiple(
    $Values: [BillMultipleDetailInput]
    $binnacle: String
    $FK_Bill: ID
  ) {
    paid: payBillCashierMultiple(
      Values: $Values
      binnacle: $binnacle
      FK_Bill: $FK_Bill
    )
  }
`;

export const updateFeatureLocation = gql`
  mutation updateFeatureLocation($id: ID, $Location_ProductFeature: String) {
    updated: updateFeatureLocation(
      id: $id
      Location_ProductFeature: $Location_ProductFeature
    ) {
      id
    }
  }
`;

export const moveProductFeatureIntoInventory = gql`
  mutation moveProductFeatureIntoInventory(
    $id: ID
    $FK_Product: ID
    $newQuantity: Int
  ) {
    moved: moveProductFeatureIntoInventory(
      id: $id
      FK_Product: $FK_Product
      newQuantity: $newQuantity
    )
  }
`;

export const updatePreparationTimeOfProductFeature = gql`
  mutation updatePreparationTimeOfProductFeature(
    $id: ID
    $PreparationTime_ProductFeature: Float
  ) {
    updated: updatePreparationTimeOfProductFeature(
      id: $id
      PreparationTime_ProductFeature: $PreparationTime_ProductFeature
    ) {
      id
      PreparationTime_ProductFeature
    }
  }
`;

export const updateCadesurCodeProductFeature = gql`
  mutation updateCadesurCodeProductFeature(
    $id: ID
    $CadesurCode_ProductFeature: String
  ) {
    updated: updateCadesurCodeProductFeature(
      id: $id
      CadesurCode_ProductFeature: $CadesurCode_ProductFeature
    ) {
      id
    }
  }
`;

export const cloneProductFeatureIntoProduct = gql`
  mutation cloneProductFeatureIntoProduct(
    $id: ID
    $FK_Product: ID
    $FK_Inventory: ID
  ) {
    cloned: cloneProductFeatureIntoProduct(
      id: $id
      FK_Product: $FK_Product
      FK_Inventory: $FK_Inventory
    )
  }
`;

export const deliveryUserPosition = gql`
  mutation deliveryUserPosition($position: DeliveryUserInput) {
    deliveryUserPosition(position: $position)
  }
`;

export const updateNextPointOfDelivery = gql`
  mutation updateNextPointOfDelivery($delivery: DeliveryInput) {
    delivery: updateNextPointOfDelivery(delivery: $delivery) {
      id
      TypeNextPoint_Delivery
      NextPoint {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      DeliveryState {
        id
        Name_DeliveryState
      }
      Created_At
      Updated_At
    }
  }
`;

export const finishBillDelivery = gql`
  mutation finishBillDelivery($id: ID) {
    bill: finishBillDelivery(id: $id) {
      status
      message
    }
  }
`;

export const updateBillDeliveryToReady = gql`
  mutation updateBillDeliveryToReady(
    $billId: ID
    $deliveryId: ID
    $firebaseId: String
  ) {
    delivery: updateBillDeliveryToReady(
      billId: $billId
      deliveryId: $deliveryId
      firebaseId: $firebaseId
    ) {
      id
    }
  }
`;

export const createDeliveryForShopperB = gql`
  mutation createDeliveryForShopperB(
    $details: [ID]
    $FK_Address: ID
    $bills: [ID]
  ) {
    delivery: createDeliveryForShopperB(
      details: $details
      FK_Address: $FK_Address
      bills: $bills
    ) {
      id
      TypeNextPoint_Delivery
      Created_At
      Updated_At
      NextPoint {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      DeliveryState {
        id
        Name_DeliveryState
      }
    }
  }
`;

export const payWithAccountFromDelivery = gql`
  mutation payWithAccountFromDelivery($FK_Account: ID, $Total: String) {
    paid: payWithAccountFromDelivery(FK_Account: $FK_Account, Total: $Total)
  }
`;

export const updateBillAsNotDelivered = gql`
  mutation updateBillAsNotDelivered(
    $id: ID
    $Description_NotDeliveredBill: String
  ) {
    updated: updateBillAsNotDelivered(
      id: $id
      Description_NotDeliveredBill: $Description_NotDeliveredBill
    )
  }
`;

export const createDelivery = gql`
  mutation createDelivery($bills: [ID], $FK_BillState: ID, $FK_Address: ID) {
    bills: createDelivery(
      bills: $bills
      FK_BillState: $FK_BillState
      FK_Address: $FK_Address
    ) {
      id
      Details_Bill
      Address {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      Detail {
        id
        Quantity_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          Details {
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Logo
                  Files {
                    id
                    Route_File
                    Created_At
                    FileType {
                      id
                    }
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Price_ProductPrice
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
    }
  }
`;

export const billToEB = gql`
  mutation billToEB($id: ID!) {
    EB: billToEB(id: $id) {
      clave
      xmlFirmado
    }
  }
`;

export const removePlaceCode = gql`
  mutation removePlaceCode($code: Int!, $id: ID!) {
    places: removePlaceCode(code: $code, id: $id) {
      id
      Code
      Name_Place
      UniqueName_Place
      Description_Place
      Logo {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      PrimaryColor_Place
      SecondaryColor_Place
    }
  }
`;

export const subscribeSudo = gql`
  mutation subscribeSudo($token: String) {
    subscribeSudo(token: $token)
  }
`;

export const updateCompanyPortraitPicture = gql`
  mutation updateCompanyPortraitPicture(
    $id: ID
    $Route_File: String
    $FirebaseId: String
    $idToDelete: ID
  ) {
    updated: updateCompanyPortraitPicture(
      id: $id
      Route_File: $Route_File
      FirebaseId: $FirebaseId
      idToDelete: $idToDelete
    ) {
      id
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
    }
  }
`;

export const updateCompanyProfilePicture = gql`
  mutation updateCompanyProfilePicture(
    $id: ID
    $Route_File: String
    $FirebaseId: String
    $fileToDelete: ID
  ) {
    updated: updateCompanyProfilePicture(
      id: $id
      Route_File: $Route_File
      FirebaseId: $FirebaseId
      fileToDelete: $fileToDelete
    ) {
      id
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
    }
  }
`;

export const createCompanyPortraitPicture = gql`
  mutation createCompanyPortraitPicture(
    $id: ID
    $Route_File: String
    $FirebaseId: String
  ) {
    updated: createCompanyPortraitPicture(
      id: $id
      Route_File: $Route_File
      FirebaseId: $FirebaseId
    ) {
      id
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
    }
  }
`;

export const updateCompanyProfileInfo = gql`
  mutation updateCompanyProfileInfo($company: CompanyInput) {
    updated: updateCompanyProfileInfo(company: $company) {
      id
      Name_Company
      Description_Company
      UniqueName_Company
      PrimaryColor_Company
      SecondaryColor_Company
      BackgroundColor_Company
      Vision_Company
      Mission_Company
    }
  }
`;

export const deleteCompanyPortraitPicture = gql`
  mutation deleteCompanyPortraitPicture($id: ID) {
    updated: deleteCompanyPortraitPicture(id: $id) {
      id
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
    }
  }
`;

export const updatePlacePicture = gql`
  mutation updatePlacePicture(
    $id: ID
    $Route_File: String
    $FirebaseId: String
    $type: ID
  ) {
    newFile: updatePlacePicture(
      id: $id
      Route_File: $Route_File
      FirebaseId: $FirebaseId
      type: $type
    ) {
      id
      Route_File
      Created_At
      FileType {
        id
      }
    }
  }
`;

export const updatePlaceProfile = gql`
  mutation updatePlaceProfile($place: PlaceInput) {
    updated: updatePlaceProfile(place: $place) {
      id
    }
  }
`;

export const createPlaceProfileTag = gql`
  mutation createPlaceProfileTag(
    $newTag: PlaceProfileTagInput
    $Route_File: String
    $FirebaseId: String
  ) {
    newTag: createPlaceProfileTag(
      newTag: $newTag
      Route_File: $Route_File
      FirebaseId: $FirebaseId
    ) {
      id
      Color_PlaceProfileTag
      Background_PlaceProfileTag
      File {
        id
        Route_File
        Created_At
      }
      Tag {
        id
        Value
      }
    }
  }
`;

export const updateOnlyPlaceProfileTagInfo = gql`
  mutation updateOnlyPlaceProfileTagInfo($tag: PlaceProfileTagInput) {
    updated: updateOnlyPlaceProfileTagInfo(tag: $tag) {
      id
      Color_PlaceProfileTag
      Background_PlaceProfileTag
    }
  }
`;

export const updateWholePlaceProfileTag = gql`
  mutation updateWholePlaceProfileTag(
    $tag: PlaceProfileTagInput
    $Route_File: String
    $FirebaseId: String
  ) {
    updated: updateWholePlaceProfileTag(
      tag: $tag
      Route_File: $Route_File
      FirebaseId: $FirebaseId
    ) {
      id
      Color_PlaceProfileTag
      Background_PlaceProfileTag
      File {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Tag {
        id
        Value
      }
    }
  }
`;

export const updateUniqueNameOfPlace = gql`
  mutation updateUniqueNameOfPlace($id: ID, $UniqueName_Place: String) {
    updated: updateUniqueNameOfPlace(
      id: $id
      UniqueName_Place: $UniqueName_Place
    ) {
      id
    }
  }
`;

export const insertSchedule = gql`
  mutation insertSchedule($schedules: [ScheduleInput]) {
    schedules: insertSchedule(schedules: $schedules) {
      id
      OpenHour_Schedule
      CloseHour_Schedule
      Detail {
        id
        Day {
          id
          Name_Day
          Value_Day
        }
      }
    }
  }
`;

export const removeSchedule = gql`
  mutation removeSchedule($id: ID) {
    deleted: removeSchedule(id: $id)
  }
`;

export const updateTag = gql`
  mutation updateTag($tag: TagInput) {
    tag: updateTag(tag: $tag) {
      id
      Value
      Clicks
      Color
      TagCategory {
        id
        Category
      }
    }
  }
`;

export const addSonTag = gql`
  mutation addSonTag($tagTree: TagTreeInput) {
    created: addSonTag(tagTree: $tagTree)
  }
`;

export const createTag = gql`
  mutation createTag($tag: TagInput) {
    newTag: createTag(tag: $tag) {
      id
      Value
      Clicks
      TagCategory {
        id
        Category
      }
    }
  }
`;
export const saveTag = gql`
  mutation SaveTag($tag: TagSaveInput!) {
    saveTag(tag: $tag) {
      id
    }
  }
`;

export const removeSonTag = gql`
  mutation removeSonTag($tagTree: TagTreeInput) {
    removed: removeSonTag(tagTree: $tagTree)
  }
`;

export const updatePromotionalCode = gql`
  mutation updatePromotionalCode($promotionalCode: PromotionalCodeInput) {
    updatedCode: updatePromotionalCode(promotionalCode: $promotionalCode) {
      id
      TotalQuantity_PromotionalCode
      EndDate_PromotionalCode
    }
  }
`;

export const updatePromotionalCodeState = gql`
  mutation updatePromotionalCodeState($id: ID, $FK_PromotionalCodeState: ID) {
    updated: updatePromotionalCodeState(
      id: $id
      FK_PromotionalCodeState: $FK_PromotionalCodeState
    ) {
      id
      State {
        id
        Name_PromotionalCodeState
      }
    }
  }
`;

export const createPromotionalCode = gql`
  mutation createPromotionalCode($promotionalCode: PromotionalCodeInput) {
    newCode: createPromotionalCode(promotionalCode: $promotionalCode) {
      id
      UniqueCode_PromotionalCode
      Discount_PromotionalCode
      SpentQuantity_PromotionalCode
      TotalQuantity_PromotionalCode
      StartDate_PromotionalCode
      EndDate_PromotionalCode
      Created_At
      Updated_At
      User {
        id
        NickName_User
      }
      State {
        id
        Name_PromotionalCodeState
      }
    }
  }
`;

export const createProductKeyFeature = gql`
  mutation createProductKeyFeature($feature: ProductKeyFeatureInput) {
    newProductKeyFeature: createProductKeyFeature(feature: $feature) {
      id
      Name_ProductKeyFeature
      Description_ProductKeyFeature
    }
  }
`;

export const insertPlaceInfo = gql`
  mutation insertPlaceInfo($placeInfo: PlaceInfoInput) {
    newPlaceInfo: insertPlaceInfo(placeInfo: $placeInfo) {
      id
    }
  }
`;

export const updatePlaceInfo = gql`
  mutation updatePlaceInfo($placeInfo: PlaceInfoInput) {
    updatedPlaceInfo: updatePlaceInfo(placeInfo: $placeInfo) {
      id
    }
  }
`;

export const deletePlaceInfo = gql`
  mutation deletePlaceInfo($id: ID) {
    deleted: deletePlaceInfo(id: $id)
  }
`;

export const aproveNotAvailableAddressToSend = gql`
  mutation aproveNotAvailableAddressToSend($id: ID) {
    aproveNotAvailableAddressToSend(id: $id) {
      id
    }
  }
`;

export const createProductDiscount = gql`
  mutation createProductDiscount($discount: ProductDiscountInput) {
    createProductDiscount(discount: $discount) {
      id
      Quantity
      StartDate
      EndDate
      Created_At
      Updated_At
      Prices
    }
  }
`;

export const setProductDiscount = gql`
  mutation setProductDiscount($FK_ProductPrice: ID!, $FK_ProductDiscount: ID!) {
    setProductDiscount(
      FK_ProductPrice: $FK_ProductPrice
      FK_ProductDiscount: $FK_ProductDiscount
    ) {
      id
      Quantity
      StartDate
      EndDate
      Created_At
      Updated_At
    }
  }
`;

export const removeProductDiscount = gql`
  mutation removeProductDiscount(
    $FK_ProductPrice: ID!
    $FK_ProductDiscount: ID!
  ) {
    removeProductDiscount(
      FK_ProductPrice: $FK_ProductPrice
      FK_ProductDiscount: $FK_ProductDiscount
    )
  }
`;

export const createCadesurFeature = gql`
  mutation createCadesurFeature($feature: CadesurCreateInput!) {
    createCadesurFeature(feature: $feature) {
      id
      CadesurCode_ProductFeature
      Quantity_ProductFeature
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Product {
        id
        Name_Product
        Description_Product
        InventoryDetail {
          id
        }
        Inventory {
          id
          Description
          Cellar {
            id
            Description
          }
        }
      }
      ProductPrice {
        Price_ProductPrice
        ProductionPrice
        Tax {
          id
          MH_Code
          Description_Tax
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Name
          Percent
          Code
        }
      }
    }
  }
`;

export const resendBillEmailTo = gql`
  mutation resendBillEmailTo($id: ID!, $to: String, $FK_Place: ID!) {
    resendBillEmailTo(id: $id, to: $to, FK_Place: $FK_Place)
  }
`;

export const updatePerson = gql`
  mutation updateUserFullInformation($user: GoogleAuthInput!) {
    updateUserFullInformation(user: $user) {
      id
      Email
      Name
      Given_Name
      Family_Name
      Phone_Number
      Updated_At
      TavuelUser {
        Person {
          ProfileImage
          BirthDate_Person
          FK_Country
          Country {
            id
            PhoneCode_Country
            Name_Country
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
    }
  }
`;

export const updateUserProfilePicture = gql`
  mutation updateUserProfilePicture($Route_File: String, $FirebaseId: String) {
    updated: updateUserProfilePicture(
      Route_File: $Route_File
      FirebaseId: $FirebaseId
    )
  }
`;

export const syncCadesurFeature = gql`
  mutation syncCadesurFeature($feature: CadesurCreateInput!) {
    syncCadesurFeature(feature: $feature) {
      id
      CadesurCode_ProductFeature
      Quantity_ProductFeature
      Updated_At
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Product {
        id
        Name_Product
        Description_Product
        InventoryDetail {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        ProductionPrice
        Updated_At
        Tax {
          id
          MH_Code
          Description_Tax
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Name
          Percent
          Code
        }
      }
    }
  }
`;

export const syncCadesurBarcodes = gql`
  mutation syncCadesurBarcodes($featureBarcodes: [CadesurBarcodeInput]) {
    syncCadesurBarcodes(featureBarcodes: $featureBarcodes) {
      Updated
      Created
    }
  }
`;

export const subscribeToPlace = gql`
  mutation subscribeToPlace($token: NotificationDeviceInput!, $id: ID!) {
    notificationDevice: subscribeToPlace(token: $token, id: $id)
  }
`;

export const subscribeUsers = gql`
  mutation subscribeUsers($token: String) {
    subscribeUsers(token: $token)
  }
`;

export const createProductFeatureTag = gql`
  mutation createProductFeatureTag($FK_ProductFeature: [ID!], $FK_Tag: ID!) {
    createProductFeatureTag(
      FK_ProductFeature: $FK_ProductFeature
      FK_Tag: $FK_Tag
    )
  }
`;

export const removeProductFeatureTag = gql`
  mutation removeProductFeatureTag($FK_ProductFeature: ID!, $FK_Tag: ID!) {
    removeProductFeatureTag(
      FK_ProductFeature: $FK_ProductFeature
      FK_Tag: $FK_Tag
    )
  }
`;

export const setPlaceDelivery = gql`
  mutation Mutation($placeDelivery: PlaceDeliveryInput) {
    savePlaceDelivery(placeDelivery: $placeDelivery) {
      id
      FK_Place
      Available
      Radius
      FreeShipping
      Price
      FK_Coin
      Coin {
        id
        Name_Coin
        Symbol_Coin
        Sell_Coin
        Buy_Coin
      }
      Latitude
      Longitude
      Address
      ProfitPercentage
    }
  }
`;

export const setPlaceDeliveryCoordinates = gql`
  mutation setCoordinates(
    $FK_Place: ID!
    $lat: Float!
    $lng: Float!
    $address: String!
  ) {
    setCoordinates(
      FK_Place: $FK_Place
      lat: $lat
      lng: $lng
      address: $address
    ) {
      id
      FK_Place
      Available
      Radius
      FreeShipping
      Price
      FK_Coin
      Latitude
      Longitude
      Address
      ProfitPercentage
    }
  }
`;

export const deletePlaceDelivery = gql`
  mutation deletePlaceDelivery($id: ID!) {
    deletePlaceDelivery(id: $id) {
      id
    }
  }
`;

export const syncCadesurPrices = gql`
  mutation syncCadesurPrices($featurePrices: [SyncCadesurPricesInput]) {
    syncCadesurPrices(featurePrices: $featurePrices) {
      id
      CadesurCode_ProductFeature
      ProductPrice {
        id
        Price_ProductPrice
        ProductionPrice
        Tax {
          id
          MH_Code
          Description_Tax
        }
        Tariff {
          id
          Code
          Name
          Percent
        }
        Cabys {
          id
          Name
          Percent
          Code
        }
      }
    }
  }
`;

export const createBillCashier = gql`
  mutation createBillCashier($detail: BillDetailInput) {
    createBillCashier(detail: $detail) {
      id
      NotAvailableAddressToSend {
        id
        Lat
        Lng
        Distance
        Amount
        Tax
        Services
        Delivery
        DeliveryTax
        Time
        User {
          id
        }
        Address {
          id
        }
        Approved
      }
      Address {
        id
        Name_Address
        Description_Address
        Lat_Address
        Lng_Address
      }
      Detail {
        id
        Quantity_BillDetail
        SubTotal_BillDetail
        Total_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
          Symbol
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          PreparationTime_ProductFeature
          Details {
            id
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
              Name_FileType
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Tags {
              id
              Value
            }
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Logo
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Schedules {
                    id
                    OpenHour_Schedule
                    CloseHour_Schedule
                    Detail {
                      id
                      Day {
                        id
                        Name_Day
                        Value_Day
                      }
                    }
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Discount {
              id
              Quantity
              StartDate
              EndDate
            }
            Price_ProductPrice
            Tax {
              id
              Description_Tax
              MH_Code
            }
            Tariff {
              id
              Name
              Code
              Percent
            }
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
    }
  }
`;

export const createBillOnly = gql`
  mutation createBillOnly($id: ID) {
    createBillOnly(id: $id) {
      id
      Details_Bill
      OrderDate_Bill
      CashAmount
      FirebaseId_Bill
      DeliveryMoment
      DeliverDate_Bill
      Total_Bill
      SubTotal_Bill
      phoneNumber
      RequiresElectronicInvoice
      HasCreditNote
      Detail {
        id
        Quantity_BillDetail
        SubTotal_BillDetail
        Total_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
          Symbol
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          PreparationTime_ProductFeature
          Details {
            id
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
              Name_FileType
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Tags {
              id
              Value
            }
            InventoryDetail {
              id
            }
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Logo
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Schedules {
                    id
                    OpenHour_Schedule
                    CloseHour_Schedule
                    Detail {
                      id
                      Day {
                        id
                        Name_Day
                        Value_Day
                      }
                    }
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Discount {
              id
              Quantity
              StartDate
              EndDate
            }
            Price_ProductPrice
            Tax {
              id
              Description_Tax
              MH_Code
            }
            Tariff {
              id
              Name
              Code
              Percent
            }
            Cabys {
              Percent
              Name
            }
          }
        }
      }
    }
  }
`;

export const updateBillDetailQuantityCashier = gql`
  mutation updateBillDetailQuantityCashier(
    $id: ID
    $quantity: Float
    $total: Float!
  ) {
    updateBillDetailQuantityCashier(id: $id, quantity: $quantity, total: $total)
  }
`;

export const createBillDetailCashier = gql`
  mutation createBillDetailCashier($detail: BillDetailInput) {
    createBillDetailCashier(detail: $detail) {
      id
      Quantity_BillDetail
      SubTotal_BillDetail
      Total_BillDetail
      UnitOfMeasurement {
        Name_UnitOfMeasurement
        Symbol
      }
      ProductFeature {
        id
        Quantity_ProductFeature
        PreparationTime_ProductFeature
        Details {
          Key_ProductKeyFeature
          Value_ProductFeatureDetail
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
            Name_FileType
          }
        }
        Product {
          id
          Name_Product
          Description_Product
          Tags {
            id
          }
          Inventory {
            id
            Cellar {
              id
              Place {
                id
                Name_Place
                Address {
                  id
                  Lat_Address
                  Lng_Address
                }
                Logo
              }
            }
          }
        }
        ProductPrice {
          id
          Price_ProductPrice
          Tax {
            id
            Description_Tax
            MH_Code
          }
          Tariff {
            id
            Name
            Code
            Percent
            Created_At
            Updated_At
          }
          Discount {
            id
            Quantity
            StartDate
            EndDate
          }
        }
      }
    }
  }
`;

export const deleteBillDetailCashier = gql`
  mutation deleteBillDetailCashier($id: ID!) {
    deleteBillDetailCashier(id: $id)
  }
`;
export const deleteProductsAndFeature = gql`
  mutation deleteProductsAndFeature($id: ID!) {
    deleteProductsAndFeature(id: $id)
  }
`;
export const updateBillUser = gql`
  mutation updateBillUser($id: ID!, $FK_User: ID) {
    updateBillUser(id: $id, FK_User: $FK_User) {
      id
    }
  }
`;

export const resendEB = gql`
  mutation resendEB($id: ID!) {
    resendEB(id: $id) {
      clave
      xmlFirmado
    }
  }
`;

export const receptionEB = gql`
  query receptionEB($id: ID!, $FK_Place: ID!) {
    receptionEB(id: $id, FK_Place: $FK_Place) {
      id
      Key
      Xml
      XmlResp
      Response
      Request
      Callback
      Created_At
      Updated_At
    }
  }
`;

export const payCartCashier = gql`
  mutation payCartCashier($cart: PayingCartInput) {
    payCartCashier(cart: $cart) {
      clave
      xmlFirmado
    }
  }
`;

export const syncCadesurCabys = gql`
  mutation syncCadesurCabys($cabys: [SyncCadesurCabysInput]) {
    syncCadesurCabys(cabys: $cabys) {
      id
    }
  }
`;

export const setDiscountState = gql`
  mutation setDiscountState($id: ID!, $State: Boolean!) {
    setDiscountState(id: $id, State: $State)
  }
`;

export const updateFeaturesQuantity = gql`
  mutation updateFeaturesQuantity($features: [ID]!, $quantity: Int!) {
    updateFeaturesQuantity(features: $features, quantity: $quantity)
  }
`;

export const updateDeliveryMoment = gql`
  mutation updateDeliveryMoment($id: ID!, $DeliveryMoment: DateTime) {
    updateDeliveryMoment(id: $id, DeliveryMoment: $DeliveryMoment)
  }
`;

export const SaveGalleryFile = gql`
  mutation SaveGalleryFile($FilePath: String, $FirebaseId: ID, $PlaceId: ID) {
    created: SaveGalleryFile(
      FilePath: $FilePath
      FirebaseId: $FirebaseId
      PlaceId: $PlaceId
    )
  }
`;

export const createRefundsByBill = gql`
  mutation createRefundsByBill($refunds: [RefundInput]!) {
    created: createRefundsByBill(refunds: $refunds)
  }
`;

export const updateRefundState = gql`
  mutation updateRefundState($refund: RefundInput!) {
    updated: updateRefundState(refund: $refund) {
      id
      FK_Bill
      ReceiptNumber
      Amount
      State
      File {
        id
        FirebaseId
        Route_File
      }
    }
  }
`;

export const updateGalleryFileState = gql`
  mutation updateGalleryFileState($id: ID!) {
    updated: updateGalleryFileState(id: $id) {
      id
      State
    }
  }
`;
export const savePermissions = gql`
  mutation savePermissions(
    $userId: Int!
    $submodules: [SaveRolePermissionSubmoduleInput]
    $placeId: Int!
  ) {
    response: savePermissions(
      userId: $userId
      submodules: $submodules
      placeId: $placeId
    ) {
      status
      message
    }
  }
`;

export const registerUserAdminByPlace = gql`
  mutation registerUserAdminByPlace($user: GoogleAuthInput!, $placeId: Int!) {
    response: registerUserAdminByPlace(user: $user, placeId: $placeId) {
      status
      message
    }
  }
`;

export const cloneRole = gql`
  mutation cloneRole($userId: Int!, $userClone: Int!, $placeId: Int!) {
    response: cloneRole(
      userId: $userId
      userClone: $userClone
      placeId: $placeId
    )
  }
`;

export const updatePlace = gql`
  mutation updatePlaceMT($place: PlaceInput) {
    response: updatePlaceMT(place: $place) {
      id
      Name_Place
      Description_Place
      Code
      Lat
      Lng
      Sinpe_Number
      Activity {
        id
        id_MH
        Name
      }
      Company {
        User {
          id
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
          }
        }
      }
      Delivery {
        id
        Radius
        Available
        Price
        Updated_At
        FreeShipping
        ProfitPercentage
      }
      Role {
        id
        Name_Role
        Value_Role
      }
      Logo
      PlaceTags {
        id
        Value
        Color
      }
    }
  }
`;
export const cancelBill = gql`
  mutation cancelBill($billId: Int!, $reason: String!, $file: FileInput) {
    response: cancelBill(billId: $billId, reason: $reason, file: $file)
  }
`;

export const editProductFeatureState = gql`
  mutation editProductFeatureState($featureId: ID, $stateId: ID) {
    response: editProductFeatureState(featureId: $featureId, stateId: $stateId) {
      id
      FK_ProductFeatureState
    }
  }
`;
